<div class="brick" [style]="style" [ngClass]="brickClass"></div>
